module.exports = __webpack_public_path__ + "static/media/passwordResetPage.af25b840.png";